import { useContext } from 'react';
import { AppContext } from '../../contexts/context';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';
import HealingIcon from '@mui/icons-material/Healing';

export const AppRepairDataCard = () => {
  const [ , dispatch ] = useContext(AppContext);

  const handleClickClear = () =>{
    dispatch({type: 'ndef/control/setForNewRead'});
  }

  return (
    <Zoom in={true} style={{ transitionDelay: '500ms'}}>
      <Card sx={{
          border: '1px solid',
          borderColor: '#d57c00',
          borderRadius: 5,
          display: "flex",
          flexDirection: "column",
          paddingX: 2,
          boxShadow: "none",
          alignItems: "left",
          justifyContent: "left"
        }}>
        <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: "#fff", padding:0.9 }} aria-label="status_icon">
                <HealingIcon color={"primary"} sx={{fontSize:50, color: '#d57c00'}}/>
              </Avatar>
            }
            title="Attention"
            subheader={"Repair Data loaded"}
            titleTypographyProps={{marginLeft:0, color:"text.primary", variant:"h6", fontWeight: 'normal'}}
        />
        <CardContent sx={{mt:0, pt:0, pb:0}}>
          <Typography variant="body2" color="text.secondary">
          Press the DATA EXCHANGE button and write the repair data to the device. Then disconnect the operating voltage for 10 seconds and reconnect it!
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            color="primary"
            sx={{color: '#d57c00'}}
            onClick={handleClickClear}
          >
            Abort
          </Button>
        </CardActions>
      </Card>
    </Zoom>
  )
}

export default AppRepairDataCard;
